export class Skills {
  constructor() {
    this.skillBars = document.querySelectorAll('.skill-progress-bar');
    this.skillsSection = document.querySelector('.skills-bars');
    this.hasAnimated = false;
    
    this.init();
  }
  
  init() {
    if (!this.skillBars.length || !this.skillsSection) return;
    
    this.setupIntersectionObserver();
  }
  
  setupIntersectionObserver() {
    const options = {
      threshold: 0.2,
      rootMargin: '0px 0px -100px 0px'
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.hasAnimated) {
          this.animateSkillBars();
          this.hasAnimated = true;
          observer.unobserve(entry.target);
        }
      });
    }, options);
    
    observer.observe(this.skillsSection);
  }
  
  animateSkillBars() {
    this.skillBars.forEach((bar, index) => {
      const width = bar.getAttribute('data-width');
      
      // Stagger the animations
      setTimeout(() => {
        bar.style.width = width;
      }, index * 100);
    });
  }
  
  reset() {
    this.skillBars.forEach(bar => {
      bar.style.width = '0';
    });
    this.hasAnimated = false;
  }
}